module.exports = __webpack_public_path__ + "static/delivery-team-1c53996cdc721564cfe2fd2ff9125783.svg";